import { isNil } from './type-guards';

export type Font = {
  family: string;
  displayName?: string;
  url?: string;
};

export const SUPPORTED_GOOGLE_FONTS = [
  'Arsenal',
  'Barlow Condensed',
  'Catamaran',
  'Chivo',
  'Corben',
  'Dancing Script',
  'Fira Mono',
  'Inconsolata',
  'Inter',
  'Lato',
  'Libre Franklin',
  'Lora',
  'Merriweather',
  'Montserrat',
  'Nunito',
  'Open Sans',
  'Oswald',
  'PT Serif',
  'Playfair Display',
  'Poppins',
  'Roboto',
  'Slabo 13px',
  'Source Sans Pro',
  'Source Serif Pro',
  'Work Sans',
  'Zilla Slab',
  'GT Walsheim',
];

export const DEFAULT_FONT_FAMILY = 'Inter';

// using document.fonts, get all fonts (loaded and unloaded) in the document
export const getFontsFromDocument = (): Map<string, FontFace> => {
  const loadedFonts = new Map<string, FontFace>();

  if (isNil(document.fonts)) {
    return loadedFonts;
  }

  document.fonts.forEach((font) => {
    loadedFonts.set(font.family, font);
  });

  return loadedFonts;
};
